import { ComponentProps, FC, memo } from 'react';

import useMwdAction from '../../hooks/useMwdAction';

import ActionLink from './ActionLink';

type ExecuteActionLinkProps = ComponentProps<typeof ActionLink> & {
  action: (() => Promise<void>) | (() => void);
};
const ExecuteActionLink: FC<ExecuteActionLinkProps> = ({ action, children, ...listItemProps }) => {
  const { executeAction } = useMwdAction();
  return (
    <ActionLink
      onClick={(event) => {
        event.preventDefault();
        if (listItemProps?.onClick) listItemProps.onClick(event);
        void executeAction(action);
      }}
      {...listItemProps}
    >
      {children}
    </ActionLink>
  );
};
export default memo(ExecuteActionLink);
